
import { defineComponent, reactive, ref } from 'vue';
import PageModel from '@/components/page-model/index.vue';

export default defineComponent({
  setup() {
    const activeKey = ref('mjstore-projectpricechangerecord');
    const tabList = reactive({
      list: [
        { modalType: 'mjstore-projectpricechangerecord', name: '单价格变动记录', id: 0 },
        { modalType: 'mjstore-cardpricechangerecord', name: '卡价格变动记录', id: 1 },
        { modalType: 'mjstore-setpricechangerecord', name: '套餐价格变动记录', id: 3 },
      ],
    });

    const getTabs = (key: any) => {
      activeKey.value = key;
    };

    return {
      tabList,
      activeKey,
      getTabs,
    };
  },
  components: {
    PageModel,
  },
});
